import React, { useRef, useState, useEffect } from "react";
import { setStorage, getStorage, deleteStorage } from "../modals/Storage";
import { API_ACCESS_URL, getURLParam } from "../modals/Constants";
import { Link, useNavigate } from "react-router-dom";
import general from "../css/General.module.css";
import DialogConfirm from "../dialogs/DialogConfirm/dialog";
import DialogWinLose from "../dialogs/DialogWinLose/dialog";
import ToastDialog from "../dialogs/ToastDialog/toast";
import MultipleCharts from "../other-components/MultipleCharts";


function Trade() {
    const navigate = useNavigate();
    const toastDialogRef = useRef(null);
    const dialogConfirmRef = useRef(null);
    const dialogWinLoseRef = useRef(null);
    const [timeout, setTimeout] = useState(0);
    const [dataInterval, setDataInterval] = useState(1);
    const [tradeOn, setTradeOn] = useState("");

    const [tradeTitle, setTradeTitle] = useState("Loading..");
    const [tradePrice, setTradePrice] = useState(0);
    const [tradeIcon, setTradeIcon] = useState("");
    const [tradeAmount, setTradeAmount] = useState("");

    const [chartData, setChartData] = useState([]);
    const [isLoadingShow, setLoadingShow] = useState(false);

    const [noticeDialogConst, setNoticeDialogConst] = useState({
        noticeTitle: "",
        noticeNote: "",
        noticeDialogShow: false,
    });

    // toast component
    const onToastChange = (data, msg) => { };

    const showToast = (message, duration, delay, mode) => {
        toastDialogRef.current.openDialog(message, duration, delay, mode);
    };

    // dialog confrim component
    const onDialogConfirm = (data, msg) => {
        if (tradeAmount > 0) {
            tradeNow()
        } else {
            showToast("Please enter the trade amount!");
        }
    };

    const showDialogConfirm = (message, trade) => {
        if (timeout > 10) {
            if (trade != "") {
                setTradeOn(trade)
            }
            dialogConfirmRef.current.openDialog(message, 0, 0);
        }
    };

    const showDialogWinLose = (message) => {
        dialogWinLoseRef.current.openDialog(message);
    };

    const onIntervalChanged = (data) => {
        if (dataInterval != data) {
            setDataInterval(data);
        }
    }

    const onInputValChange = (data, operation) => {
        if (data !== "") {
            if (operation === "+2") {
                data = data * 2;
            } else if (operation === "-2") {
                data = data / 2;
            }

            if (data >= 0 && data % 1 === 0) {
                const dataStr = String(data);

                if (dataStr.includes(".")) {
                    data = dataStr.replace(".", ""); // Remove the dot
                }

                setTradeAmount(Number(data));
            }
        } else {
            setTradeAmount("");
        }
    }

    const signOutAccount = () => {
        if (deleteStorage()) {
            navigate("/login", { replace: true });
        }
    }

    function tradeNow() {
        const requestAPI = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        route: "route-invest-trade",
                        AuthToken: getStorage("secret"),
                    },
                    body: JSON.stringify(formData),
                });
                const data = await res.json();

                setLoadingShow(false);

                if (data.status_code == "success") {
                    setTradeAmount("");
                    setStorage("balance", data.balance);
                    setStorage("tradeid", data.tradeid);

                    dialogConfirmRef.current.openDialog("Trade placed successfully.", 0, 1);
                } else if (data.status_code == "insufficient_balance") {
                    showToast("Insufficient Balance! Please deposit now to trade.");
                } else if (data.status_code == "already_exist") {
                    showToast("Trade is already pending! Please wait until it is completed.");
                } else if (data.status_code == "authorization_error") {
                    signOutAccount();
                }
            } catch (error) {
                setLoadingShow(false);
            }
        };

        if (!isLoadingShow) {
            setLoadingShow(true);
            const formData = {
                ACCOUNT_ID: getStorage("uid"),
                SERVICE_ID: getURLParam('id'),
                TRADE_ON: tradeOn,
                TRADE_AMOUNT: tradeAmount,
                TRADE_INTERVAL: dataInterval,
            };
            requestAPI(API_ACCESS_URL, formData);
        }
    }

    function initializeTrading() {
        const requestAPI = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        route: "route-setup-trade",
                        AuthToken: getStorage("secret"),
                    },
                    body: JSON.stringify(formData),
                });
                const data = await res.json();
                setLoadingShow(false);

                if (data.status_code == "success") {
                    let balance = data.balance;
                    setStorage("balance", balance);

                    setTimeout(data.time_left);

                    // Update the chart data
                    setChartData(data.data);
                    setTradeTitle(data.title);
                    setTradePrice(data.price);
                    setTradeIcon(data.icon);

                    if (getStorage("tradeid") != "" && getStorage("tradeid") == data.records[0]['id']) {
                        if (data.records[0]['status'] == "profit") {
                            setStorage("tradeid", "");
                            showDialogWinLose("₹" + data.records[0]['amount']);
                        }
                    }
                } else if (data.status_code == "authorization_error") {
                    signOutAccount();
                }
            } catch (error) {
                setLoadingShow(false);
            }
        };

        if (!isLoadingShow) {
            setLoadingShow(true);
            const formData = {
                ACCOUNT_ID: getStorage("uid"),
                SERVICE_ID: getURLParam('id'),
                RECORDS: true,
                INTERVAL: dataInterval
            };
            requestAPI(API_ACCESS_URL, formData);
        }
    }

    useEffect(() => {
        initializeTrading();
    }, [dataInterval]);

    useEffect(() => {
        if (getURLParam('id') == null || getURLParam('id') == "") {
            signOutAccount();
        }
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (timeout == 0) {
                setTimeout(60);
                initializeTrading();
            } else {
                setTimeout(timeout - 1);
            }
        }, 1000);

        // Clear the interval
        return () => clearInterval(intervalId);
    }, [timeout]);

    return (
        <div className={[general.appContents].join(" ")}>
            <ToastDialog onToastChange={onToastChange} ref={toastDialogRef} />
            <DialogConfirm onConfirmed={onDialogConfirm} ref={dialogConfirmRef} />
            <DialogWinLose onConfirmed={onDialogConfirm} ref={dialogWinLoseRef} />

            <div
                className={[
                    general.respWidth,
                    general.height100vh,
                    general.colView
                ].join(" ")}
            >
                <div className="w-100 ps-sticky ps-tp row-view sb-view pd-10-15 bg-custom-1 z-i-90">
                    <div className="row-view">
                        <img
                            src={require('../media/icons/angle_left_white_icon.png')}
                            className="w-30-p pd-5"
                            alt="icon"
                            onClick={() => navigate(-1)}
                        />

                        <div className="row-view mg-l-15">
                            <img
                                src={tradeIcon}
                                className={`w-30-p ${tradeIcon != "" ? 'opac-f' : 'opac-0'}`}
                                alt="icon"
                            />
                            <div className="col-view mg-l-10">
                                <p className="ft-sz-18 cl-white">{tradeTitle}</p>
                                <p className="ft-sz-16 cl-l-white">Balance: ₹{getStorage("balance")}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row-view cl-white pd-5-10 br-5 bg-primary">
                        <div className="h-w-10 bg-green br-50 fadein-anim"></div>
                        <span className="w-30-p v-center ft-sz-18 mg-l-5">{timeout}</span>
                    </div>
                </div>

                <div className="pd-10-15 mg-t-5 bg-custom-1">
                    <p className="ft-sz-16 cl-l-white">Trade Intervals</p>

                    <div className="row-view mg-t-10">
                        <div className={`d-block txt-deco-n ft-sz-14 pd-5-10 cl-white br-5 ${dataInterval === 1 ? 'bg-selected' : 'bg-primary'}`} onClick={() => onIntervalChanged(1)}>
                            {dataInterval === 1 ? <i className='bx bx-check'></i> : null}
                            <span className="mg-l-10">1 Min</span>
                        </div>
                        <div className={`d-block txt-deco-n ft-sz-14 pd-5-10 cl-white br-5 mg-l-5 ${dataInterval === 5 ? 'bg-selected' : 'bg-primary'}`} onClick={() => onIntervalChanged(5)}>
                            {dataInterval === 5 ? <i className='bx bx-check'></i> : null}
                            <span className="mg-l-10">5 Min</span>
                        </div>
                        <div className={`d-block txt-deco-n ft-sz-14 pd-5-10 cl-white br-5 mg-l-5 ${dataInterval === 10 ? 'bg-selected' : 'bg-primary'}`} onClick={() => onIntervalChanged(10)}>
                            {dataInterval === 10 ? <i className='bx bx-check'></i> : null}
                            <span className="mg-l-10">10 Min</span>
                        </div>
                    </div>
                </div>

                <div className="chart-view">
                    <MultipleCharts data={chartData} price={tradePrice} />
                </div>

                <div className="pd-10-15 bg-custom-1">
                    <div className="row-view sb-view">
                        <div className="row-view">
                            <img
                                src={require('../media/icons/info_icon.png')}
                                className="w-20-p"
                                alt="icon"
                            />
                            <p className="ft-sz-18 cl-l-white mg-l-10">Invest</p>
                        </div>
                        <Link className="txt-deco-n ft-sz-16 pd-5-10 cl-white" to={"/traderecords?id=" + getURLParam('id')}>Trade History</Link>
                    </div>

                    <div className="row-view pd-0-15 bg-l-white mg-t-15">
                        <span className="line-h-15px cl-white ft-sz-18 pd-10-15 br-5 bg-selected" onClick={() => onInputValChange(tradeAmount, "-2")}>-2x</span>
                        <input
                            type="number"
                            className="cutm-inp ft-sz-20 h-60-p cl-white inp-ph-l-color mg-l-15"
                            value={tradeAmount}
                            placeholder="Enter Amount"
                            onChange={(e) =>
                                onInputValChange(e.target.value)
                            }
                        ></input>
                        <span className="line-h-15px cl-white ft-sz-18 pd-10-15 br-5 bg-selected" onClick={() => onInputValChange(tradeAmount, "+2")}>+2x</span>
                    </div>

                    <div className={`row-view mg-t-20 ${timeout < 10 ? 'disable-view' : ''}`}>
                        <div className="w-100 v-center ft-sz-20 pd-10-20 cl-white br-5 bg-green" onClick={() => showDialogConfirm("Are you sure you want to trade?", "CALL")}>
                            <i className='bx bx-up-arrow-alt'></i><span className="mg-l-10">Call</span>
                        </div>
                        <div className="w-100 v-center ft-sz-20 pd-10-20 cl-white mg-l-10 br-5 bg-red" onClick={() => showDialogConfirm("Are you sure you want to trade?", "PUT")}>
                            <i className='bx bx-down-arrow-alt' ></i><span className="mg-l-10">Put</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Trade;